import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { MAPLIBRE_VEHICLE_CAR_SIZE_PX } from "./maplibre-vehicle-car-marker.constants";

export const MapLibreVehicleCarRoot = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-vehicle-car-marker",
})<{ $fillColor: string; $isDetour?: boolean }>`
  position: relative;
  display: block;
  width: ${MAPLIBRE_VEHICLE_CAR_SIZE_PX}px;
  height: ${MAPLIBRE_VEHICLE_CAR_SIZE_PX}px;
  line-height: 0;
  flex-shrink: 0;
  overflow: visible;
  pointer-events: auto;
  color: ${rydeColors.white};

  & > svg {
    display: block;
    width: ${MAPLIBRE_VEHICLE_CAR_SIZE_PX}px;
    height: ${MAPLIBRE_VEHICLE_CAR_SIZE_PX}px;
  }

  & .maplibre-vehicle-car-fill {
    fill: ${({ $fillColor }) => $fillColor};
  }

  & .maplibre-vehicle-car-icon {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${rydeColors.white};
    pointer-events: none;
    line-height: 0;
  }

  ${({ $isDetour }) =>
    $isDetour
      ? `
    &::before {
      content: "";
      position: absolute;
      inset: -4px;
      border-radius: 50%;
      border: 2px solid currentColor;
      opacity: 0.7;
      pointer-events: none;
      animation: maplibre-vehicle-car-pulse 1.4s ease-out infinite;
    }

    @keyframes maplibre-vehicle-car-pulse {
      0% {
        transform: scale(1);
        opacity: 0.7;
      }
      100% {
        transform: scale(1.35);
        opacity: 0;
      }
    }
  `
      : ""}
`;
